/** Gives an editor with unsaved changes a chance to keep the current section open. */
export function requestAdminNavigation(sectionId?: string): boolean {
  return window.dispatchEvent(
    new CustomEvent('admin-before-navigate', {
      cancelable: true,
      detail: sectionId,
    }),
  )
}

export function hasUnsavedAdminWork(): boolean {
  return !window.dispatchEvent(
    new CustomEvent('admin-has-unsaved-work', { cancelable: true }),
  )
}
